import limitValue from "../../../../utils/limit-value";
import round from "../../../../utils/round";
import WINDOW from "../../../../utils/window";

/**
 * Get default scroll percents
 * @param {Boolean} page Take a full page into a count
 * @param {Number} start
 * @param {Number} end
 * @param {"height" | "width"} dimension Window dimension
 * @param {Number} bounds
 * @returns
 */
const getScrollDefaultPercents = (page, start, end, dimension, bounds) => {
  let position;
  let percents;

  const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));
  const scrollY = /** @type {Number} */ (scroll.get("y"));
  const window = /** @type {Number} */ (WINDOW.get(dimension));

  if (page) {
    position = scrollY - start;
    percents = position / (end - start - position);
  } else {
    position = window + scrollY - bounds - start;
    percents = position / (window - (window - end) - start);
  }

  percents = round(limitValue(percents));

  return percents;
};

export default getScrollDefaultPercents;
